module.exports = __webpack_public_path__ + "assets/tag-2be4cf.svg";